import React from 'react'
import ReportComponent from '../components/report/ReportComponent'

export default function Report() {
  return (
    <div>
      <ReportComponent />
    </div>
  )
}
